export const DoubleClickRename = {
  recordId() {
    return this.el.dataset.id || this.el.dataset.convId;
  },

  editEvent() {
    return this.el.dataset.editEvent || "start_editing_title";
  },

  clickEvent() {
    return this.el.dataset.clickEvent || "navigate_to_conversation";
  },

  mounted() {
    this.clickPending = false;
    this.clickTimer = null;

    this.el.addEventListener("dblclick", (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (this.clickTimer) {
        clearTimeout(this.clickTimer);
        this.clickTimer = null;
      }
      this.clickPending = false;

      this.pushEvent(this.editEvent(), { id: this.recordId() });
    });

    this.el.addEventListener("click", (e) => {
      if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      if (this.clickPending) {
        return;
      }

      this.clickPending = true;

      this.clickTimer = setTimeout(() => {
        if (this.clickPending) {
          this.clickPending = false;
          this.pushEvent(this.clickEvent(), { id: this.recordId() });
        }
      }, 200);
    });
  },

  destroyed() {
    if (this.clickTimer) {
      clearTimeout(this.clickTimer);
    }
    this.clickPending = false;
  },
};
